/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const WrapperMetrics = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  .section-grid {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    @media screen and (max-width: 900px) {
      grid-template-columns: repeat(4, 1fr);
    }
    @media screen and (max-width: 400px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .section-metric {
    display: flex;
    flex-direction: column;
    padding: 10px;
    margin: 5px;
  }
  .section-icon {
    width: 50px;
    height: 50px;
    border-radius: 10px;
    background-color: #e1eaff;
    padding: 5px;
  }
  .text-metric {
    display: flex;
    flex-direction: column;
    padding: 15px;
    justify-content: flex-start;
    align-items: flex-start;
  }
  h2 {
    font-weight: bold;
  }
  h4 {
    font-weight: 400;
  }
  strong {
    font-size: 14px;
    text-align: center;
    font-weight: 400;
  }
  .rounded-div {
    border-radius: 50%;
    height: 20px;
    width: 20px;
    margin: 6px;
  }
  .section-point {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 5px;
  }
  .section-percentage {
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    text-align: center;
  }
  .unclickable-indicator {
    pointer-events: none;
    cursor: default;
  }
`;
